import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { MAX_RETRIES } from '#pplx/frontend/api-clients/core/utils.js';
import { TASK_OPERATION_TIMEOUT_MS } from '#pplx/frontend/apps/ask/queries/tasks-queries/constants.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { tasksClient } from '#pplx_generated/typespec/rest/tasks/client.js';
export const getShortcutsTypeahead = async ({ reason, headers, }) => {
    const { data, error, response } = await tasksClient.GET('/rest/tasks/shortcuts/mentions', reason, {
        params: { query: { order_by: 'created_at' } },
        timeoutMs: TASK_OPERATION_TIMEOUT_MS,
        numRetries: MAX_RETRIES,
        headers,
    });
    if (error) {
        logger.error('Failed to get shortcut typeahead options', error);
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=getShortcutsTypeahead.js.map